<template>
  <div class="row justify-content-center">
    <div class="col-md-5" >
      <h2 style="margin-bottom: 20px;">Esito Pagamento</h2>
        <p><strong>Pagamento OK!</strong></p>
        <p>Grazie per aver scelto DogMotics</p>
        <button @click="close" class="mr-1" variant="secondary">CHIUDI</button>
    </div>
  </div>
</template>

<script>
  //import { auth } from '../../firebase/config.js';
  export default {
    data() {
      return {
      }
    },
    methods: {
      close(event) {
        event.preventDefault()
        this.$router.push({ name: 'user_profile' })
/*      }
        auth.signOut()
        .then(() => {
          //this.set_user_loggedIn(false)
          this.$router.replace({ name: "login" });
        })*/
      }
    }
  };
</script>